<template>
    <div id="app">
        <div v-if="loginFlag" class="dis">
            <div :class="isCollapse?'menu collapse':'menu'" style="z-index:9999;">
                <div class="logo">{{isCollapse?'后台':'后台管理'}}</div>
                <el-menu :default-active="activeRouter" background-color="rgba(35,32,33,1)" text-color="#8D8E8F" active-text-color="#fff" class="el_menu" @open="handleOpen" @close="handleClose" :collapse="isCollapse" :collapse-transition="false">
                    <div v-for="(item,index) in menuList"  :key="index">
                        <el-menu-item v-if="!item.module.group" :index="index.toString()" @click="goTo(item.module.id,index)">
                            <img v-if="activeRouter !== index.toString()" :src="item.module.pic" alt="">
                            <img v-if="activeRouter == index.toString()" :src="item.module.picActive" alt="">
                            <span slot="title">{{item.module.name}}</span>
                            <template slot="title" v-if="item.module.group">
                                <img v-if="activeRouter !== index.toString()" :src="item.module.pic" alt="">
                                <img v-if="activeRouter == index.toString()" :src="item.module.picActive" alt="">
                                <span>{{item.module.name}}</span>
                            </template>
                        </el-menu-item>
                        <el-submenu v-else :index="index.toString()" :open="activeRouter">
                            <template slot="title">
                                <img :src="item.module.pic" alt="">
                                <span v-if="!isCollapse">{{item.module.name}}</span>
                            </template>
                            <el-menu-item style="margin-left: 15px" :index="index.toString()+'-'+index2.toString()" :key="index2" v-for="(item2,index2) in item.module.group" @click="goTo2(item2.id,index.toString()+'-'+index2.toString())">{{item2.name}}</el-menu-item>
                        </el-submenu>
                    </div>

                </el-menu>
            </div>
            <div :class="isCollapse?'collapse_main main':'main'">
                <div class="header">
                    <div class="l">
                        <img src="./assets/img/close_menu.png" alt="" @click="collapseChange">
                        <div>{{title}}</div>
                    </div>
                    <el-dropdown style="display:block;">
                        <div class="r">
                            <img src="./assets/img/avatar.png" alt="">
                            <div>{{name}}</div>
                        </div>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div class="content">
                    <router-view></router-view>
                </div>
            </div>
        </div>
        <router-view v-if="!loginFlag"></router-view>
    </div>
</template>

<script>
    import config from '@/assets/js/config'
    export default {
        data() {
            return {
                name:sessionStorage.getItem('name'),
                loginFlag: false,
                activeRouter:'0',
                isCollapse: false,
                title:'',
                menuList:[]
            }
        },
        methods: {
            handleOpen(key, keyPath) {
                // console.log(key, keyPath);
            },
            handleClose(key, keyPath) {
                // console.log(key, keyPath);
            },
            goTo (v,i) {
                // console.log(v,i)
                this.activeRouter = i.toString()
                this.$router.push(v)
            },
            goTo2 (v,i) {
                // console.log('11')
                // console.log(v,i)
                this.activeRouter = i
                this.$router.push(v)
            },
            collapseChange () {
                this.isCollapse = !this.isCollapse
            },
            logout() {
                sessionStorage.removeItem('uKey')
                sessionStorage.removeItem('name')
                this.$router.push('/login')
                this.menuList = []
            }
        },
        created() {
            if (sessionStorage.getItem('uKey') && this.$route.path !== '/login') {
                this.loginFlag = true
            }
            else {
                this.loginFlag = false
            }
            if (sessionStorage.getItem('uKey') == 1) {
                this.menuList = config.list
                config.list.forEach((item,idx) => {
                    if(!item.module.group) {
                        if ('/'+item.module.id == this.$route.path) {
                            this.title = item.module.name
                            this.activeRouter = idx.toString()
                        }
                    }
                    else{
                        item.module.group.forEach((item2,idx2) => {
                            if ('/'+item2.id == this.$route.path) {
                                this.title = item.module.name
                                this.activeRouter = idx.toString()+'-'+idx2.toString()
                            }
                        })
                    }
                });
                if(this.$route.path == '/') {
                    this.activeRouter = '0'
                    this.title = config.list[0].module.name
                }
            } else{
                this.menuList = []
            }
        },
        watch: {
            '$route' (to, from) {
                if (sessionStorage.getItem('uKey') && this.$route.path !== '/login') {
                    this.loginFlag = true
                }
                else {
                    this.loginFlag = false
                }
                if (sessionStorage.getItem('uKey') == 1) {
                    this.menuList = config.list
                    config.list.forEach((item,idx) => {
                        if(!item.module.group) {
                            if ('/'+item.module.id == this.$route.path) {
                                this.title = item.module.name
                                this.activeRouter = idx.toString()
                            }
                        }
                        else{
                            item.module.group.forEach((item2,idx2) => {
                                if ('/'+item2.id == this.$route.path) {
                                    this.title = item.module.name
                                    this.activeRouter = idx.toString()+'-'+idx2.toString()
                                }
                            })
                        }
                    });
                    if(this.$route.path == '/') {
                        this.activeRouter = '0'
                        this.title = config.list2[0].module.name
                    }
                }
                else{
                    this.menuList = []
                }
                this.name = sessionStorage.getItem('name')
            }
        }
    }
</script>

<style lang="scss">
    body{
        background: #F5F6FB!important;
    }
    #app{
        width: 100%;
        height: 100%;
    }
    .el_menu:not(.el-menu--collapse) {
        width: 180px;
        min-height: calc(100vh - 60px);
        border: none;
    }
    .el-menu--collapse{
        width: 60px!important;
        min-height: calc(100vh - 60px);
        border-right: 0;
    }
    .is-active{
        position: relative;
        //background-color: rgba(201,160,108,0.1)!important;
    }
    .el-submenu__title:hover{
        background-color: transparent !important;
    }
    .el-menu-item:hover{
        background-color: transparent !important;
    }
    .el-menu-item, .el-submenu__title{
        height: 40px!important;
        line-height: 40px!important;
    }
    .el-submenu__title:hover{
        background-color: #232021!important;
    }
    .is-active::before{
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        content:'';
        width:4px;
        height:30px;
        //background:rgba(201,160,108,1);
        border-radius:0px 3px 3px 0px;
    }
    .menu{
        width: 180px;
        display: inline-block;
        background:rgba(35,32,33,1);
        img{
            width: 18px;
            height: 18px;
            margin-right: 10px;
        }
        .logo{
            height:60px;
            font-size:18px;
            line-height:60px;
            text-align: center;
            background:rgba(35,32,33,1);
            color:rgba(201,160,108,1);
        }
    }
    .collapse{
        width: 60px;
    }
    .main{
        width: calc(100% - 180px);
        display: inline-block;
        vertical-align: top;
        .header{
            width:100%;
            height:55px;
            line-height: 55px;
            background:rgba(255,255,255,1);
            box-shadow:0px 2px 8px 0px rgba(0,0,0,0.1);
            overflow: hidden;
            .l{
                float: left;
                img{
                    width:32px;
                    height:32px;
                    border-radius:2px;
                    margin: 12px 10px 0 30px;
                    vertical-align: top;
                }
                i{
                    font-size: 20px;
                    line-height: 55px;
                    vertical-align: top;
                    margin: 0 18px 0 30px;
                }
                div{
                    display: inline-block;
                    font-size:14px;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                }
            }
            .r{
                float: right;
                img{
                    display: inline-block;
                    width:32px;
                    height:32px;
                    border-radius: 50%;
                    margin-top: 12px;
                    vertical-align: top;
                    min-height: 32px;
                }
                div{
                    display: inline-block;
                    font-size:14px;
                    margin: 0 30px 0 8px;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                }
            }
        }
        .content{
            width: 100%;
            min-height: calc(100vh - 55px);
        }
    }
    .dis {
        display: inline-flex;
        flex-direction: row;
        width: 100vw;
    }
    .main.collapse_main{
        width: calc(100% - 60px);
    }
</style>
